import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonIcon } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonIcon), { icon: _ctx.icon }, null, 8, ["icon"]))
}
}

})